/* eslint-disable */

/* This file is generated, don't modify directly. See README.md in Icon folder */
import React from 'react';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
type Props = Omit<SvgIconProps, 'viewBox'>;
export function IconMore1(props: Props) {
    const newProps = { ...props, viewBox: '0 0 32 32' };
    return React.createElement(
        SvgIcon,
        newProps,
        <path
            d="M5.037 19.037a3.037 3.037 0 100-6.075 3.037 3.037 0 000 6.075zm21.926 0a3.037 3.037 0 100-6.075 3.037 3.037 0 000 6.075zm-10.963 0a3.037 3.037 0 100-6.075 3.037 3.037 0 000 6.075z"
            fill="currentColor"
        />
    );
}
